/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-const-assign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import {
  MapContainer,
  TileLayer,
  Popup,
  Marker,
  useMap,
  useMapEvents,
} from 'react-leaflet'
import { useHistory } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import 'leaflet/dist/leaflet.css'
import { FaCrosshairs } from 'react-icons/fa'
import L from 'leaflet'
import { AiOutlineLeftCircle } from 'react-icons/ai'
import { UploadsUrl } from '../../services/url'
import { Context } from '../../context/context'
import { averageGeolocation } from '../../utilities/method'
import { ShortString } from '../../utilities/generator'
const icon = L.icon({
  iconSize: [25, 41],
  iconAnchor: [10, 41],
  popupAnchor: [2, -40],
  iconUrl: '/images/maker.png',
})

const MapPage = (props) => {
  const AppContext = useContext(Context)
  const [location, setLocation] = useState(false)
  const [modalService, setModalService] = useState(false)
  const [lawyerId, setLawyerId] = useState(null)
  const [servicesLawyer, setServicesLawyer] = useState([])
  const [position, setPosition] = useState([35.6892, 51.389])
  const [zoom, setZoom] = useState(12)
  const [markersGps, setMarkersGps] = useState([])
  const router = useHistory()

  const GetLawyer = (lawyer) => {
    localStorage.setItem('serviceType', null)
    if (props.chooseTypesWork.length == 0) {
      setModalService(true)
      setLawyerId(lawyer._id)
      setServicesLawyer(lawyer.services)
    } else {
      localStorage.setItem('serviceLawyer', props.chooseTypesWork[0])
      router.push(`/detail-lawyer/${lawyer._id}`)
    }
  }

  const setService = (id) => {
    localStorage.setItem('serviceType', null)
    localStorage.setItem('serviceLawyer', id)
    router.push(`/detail-lawyer/${lawyerId}`)
  }

  const ChangeView = () => {
    const map = useMap()
    if (props.addressCordinate) {
      setZoom(12)
      map.flyTo(props.addressCordinate, zoom)
    } else if (AppContext.GPS) {
      setZoom(12)
      map.flyTo(AppContext.GPS, zoom)
    } else {
      setZoom(5)
      var arr = []
      for (let i in props.lawyers) {
        if (props.lawyers[i].coordinates[0] != '0') {
          arr.push({
            latitude: Number(props.lawyers[i].coordinates[0]),
            longitude: Number(props.lawyers[i].coordinates[1]),
          })
        }
      }
      if (arr.length > 1) {
        map.flyTo(averageGeolocation(arr), zoom)
      } else if (arr.length == 1) {
        map.flyTo([arr[0].latitude, arr[0].longitude], zoom)
      }
    }
    return null
  }

  const GetLocation = () => {
    const map = useMap()
    useEffect(() => {
      map.locate().on('locationfound', function (e) {
        map.flyTo(e.latlng, zoom)
        AppContext.setGPS([String(e.latlng.lat), String(e.latlng.lng)])
      })
    }, [map])
    setLocation(false)
    return null
  }
  const setLocations = () => {
    setLocation(true)
    setZoom(12)
    return <GetLocation />
  }

  return (
    <>
      <MapContainer
        className='map'
        center={position}
        zoom={zoom}
        scrollWheelZoom={true}
        zoomControl={false}
      >
        <TileLayer
          attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
          url='https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
        />
        <MyVerticallyCenteredModal
          show={modalService}
          onHide={() => setModalService(false)}
        >
          <ul className='modal-typeWork-parent'>
            {servicesLawyer.map((serivcse) =>
              props.typesWork.map(
                (typeWork, index) =>
                  serivcse._id == typeWork._id && (
                    <li
                      className='modal-typeWork'
                      onClick={() => setService(typeWork._id)}
                      key={index}
                    >
                      {typeWork.title}
                    </li>
                  )
              )
            )}
          </ul>
        </MyVerticallyCenteredModal>
        {props.lawyers.map(
          (lawyer, index) =>
            lawyer.coordinates[0] != '0' && (
              <Marker position={lawyer.coordinates} icon={icon} key={index}>
                <Popup>
                  <div className='user-marker'>
                    <div>
                      <img src={`${UploadsUrl}/${lawyer.avatar}`} alt='user' />
                    </div>
                    <div className='detail-marker'>
                      <h5>
                        {ShortString(`${lawyer.fname + ' ' + lawyer.lname}`)}
                      </h5>
                      <div>
                        <span>
                          <AiOutlineLeftCircle size={20} />
                        </span>
                        <span
                          className='link'
                          onClick={() => GetLawyer(lawyer)}
                        >
                          جزئیات بیشتر
                        </span>
                      </div>
                    </div>
                  </div>
                </Popup>
              </Marker>
            )
        )}
        <ChangeView />
        {location && <GetLocation />}
      </MapContainer>
      <button
        className='buttonBase-0-2-16 box-shadow'
        onClick={() => setLocations()}
      >
        <FaCrosshairs />
      </button>
    </>
  )
}
export default MapPage

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size='md'
      aria-labelledby='contained-modal-title-vcenter'
      centered
    >
      <Modal.Header
        closeButton
        style={{ padding: '0px 20px', paddingTop: '0px' }}
      >
        <h6 className='text-center'>موضوع خود را انتخاب کنید</h6>
      </Modal.Header>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  )
}
